/**
 * Helpers — generic plumbing shared by the other modules: debug logging and
 * analytics dispatch. Bundle-internal (imported, never exposed on window).
 *
 * Split from Controllers on purpose: Controllers holds DOMAIN utilities
 * (phone formatting, availability checks); Helpers holds infrastructure that
 * any module might need regardless of what the component does.
 */

var Helpers = new Object();

/**
 * Debug-gated console logger. Every module logs through this so the
 * component's `debug` flag (from the template config) is respected in one
 * place and all output carries the same prefix.
 *
 * @param {object} component  Alpine component (read .debug)
 * @param {...*}   args       Anything console.log accepts
 */
Helpers.log = function (component, ...args) {

  if (!component || !component.debug) return;

  console.log('[ThryvConnectBar]', ...args);

};

/**
 * Analytics dispatch: pushes the payload to the GTM dataLayer AND fires a
 * DOM CustomEvent of the same name (the theme's helpers.dispatchEvent) for
 * any JS listeners. Both are needed — the theme helper alone never reaches
 * the dataLayer, it only dispatches DOM events. Never throws when neither
 * mechanism exists.
 *
 * @param {string} eventName  e.g. 'connect_bar_click'
 * @param {object} payload    dataLayer-shaped payload
 */
Helpers.dispatch = function (eventName, payload) {

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);

  if (typeof window.helpers === 'object' && typeof window.helpers.dispatchEvent === 'function') {

    window.helpers.dispatchEvent(eventName, payload);

  }

};

/**
 * Load scripts SEQUENTIALLY — each waits for the previous one so dependency
 * order holds when multiple entries are passed. Idempotent per URL
 * (ignoring any ?ver cache-buster).
 *
 * @param  {Array<string|object>} entries  URL strings, or {src, module,
 *                                         crossorigin} for ESM loaders like
 *                                         the CP Chat widget
 * @return {Promise}  Resolves when every script has loaded
 */
Helpers.loadScripts = function (entries) {

  return (entries || []).reduce(function (chain, entry) {

    return chain.then(function () {

      var src = typeof entry === 'string' ? entry : entry.src;
      var bare = src.split('?')[0];

      if (document.querySelector('script[src^="' + bare + '"]')) return;

      return new Promise(function (resolve, reject) {

        var script = document.createElement('script');
        script.src = src;

        if (typeof entry === 'object' && entry.module) script.type = 'module';
        if (typeof entry === 'object' && entry.crossorigin) script.crossOrigin = entry.crossorigin;

        script.onload = resolve;
        script.onerror = function () {

          reject(new Error('Failed to load ' + src));

        };
        document.body.appendChild(script);

      });

    });

  }, Promise.resolve());

};

export default Helpers;
